import {
  API_REO_ALL_DOCUMENTS,
  API_REO_CONTACT,
  API_REO_CONTACT_BY_ID,
  API_REO_DATA,
  API_REO_DOCUMENT_DATA,
  API_REO_DOWNLOAD_DOCUMENT,
  API_REO_HISTORY,
  API_REO_RENTAL_LEDGER,
  API_REO_SEND_DOCUMENT_EMAIL,
} from 'config'
import Api from 'services/api'

import { downloadFile } from '../documents'

export const getRentalLedgers = () => {
  return Api.get(API_REO_RENTAL_LEDGER)
}
export const updateRentalLedger = (data: Record<string, any>) => {
  return Api.put(API_REO_RENTAL_LEDGER, data)
}

export const getRealEstateOwned = (key: string) => {
  return Api.get(API_REO_DATA, { key })
}
export const updateRealEstateOwned = (key: string, data: Record<string, any>) => {
  return Api.put(API_REO_DATA, { key, data })
}

export const getRealEstateOwnedLogs = (key: string, field: string) => {
  return Api.get(API_REO_HISTORY, { key, field })
}

export const getReoContacts = () => {
  return Api.get(API_REO_CONTACT)
}

export const addNewReoContact = (data: Record<string, any>) => {
  return Api.post(API_REO_CONTACT, data)
}

export const updateReoContact = (id: number, data: Record<string, any>) => {
  return Api.put(API_REO_CONTACT_BY_ID, data, { id })
}

export const deleteReoContact = (id: number) => {
  return Api.delete(API_REO_CONTACT_BY_ID, {}, { id })
}

export const getReoDocumentData = () => {
  return Api.get(API_REO_DOCUMENT_DATA)
}

export const getAllReoDocuments = () => {
  return Api.get(API_REO_ALL_DOCUMENTS)
}

export const downloadReoDocument = async (doc: Record<string, any>, format: 'pdf' | 'docx' = 'pdf') => {
  const response: Blob = await Api.post(
    API_REO_DOWNLOAD_DOCUMENT,
    { name: doc.name, format },
    {},
    {
      responseType: 'blob',
    },
  )

  // Api.post with responseType blob still resolves on 4xx/5xx in some paths; guard mislabeled Word.
  if (format === 'docx') {
    const head = new Uint8Array(await response.slice(0, 4).arrayBuffer())
    const isPdf = head[0] === 0x25 && head[1] === 0x50 && head[2] === 0x44 && head[3] === 0x46
    if (isPdf || response.type?.includes('text') || response.type?.includes('json')) {
      const message = await response.text()
      throw new Error(message || 'Word download is not available from Docgen yet.')
    }
  }

  downloadFile(`${doc.name} - ${Api.getLoanNumber()}.${format}`, response)
}

export const sendReoDocumentOnEmail = (
  doc: Record<string, any>,
  emailData: Record<string, string>,
  data: Record<string, any>,
) => {
  return Api.post(API_REO_SEND_DOCUMENT_EMAIL, { name: doc.name, emailData, data })
}
